/*
    default prefix "LIST"
*/
export const AT_UPDATE = 'LIST_UPDATE';
export const AT_CARD_IDS_SET = 'LIST_CARD_IDS_SET';
